import Component from '../../../shared/component';

export default class GroupSelect extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.$groups = this.$element.find('.groupsList-item-link');

    this.currentPageFormat = this.checkPageFormat();
    this.oldPageFormat = this.currentPageFormat;

    if (window.$window.width() > window.pageContentWidthMd) {
      this.bindTimeouts();
    }

    this.bindEvents();
  }

  bindEvents() {
    this.handleResize = this.handleResize.bind(this);

    window.$window.on('resize.GroupSelect', this.handleResize);
  }

  unbindEvents() {
    window.$window.off('resize.GroupSelect', this.handleResize);
  }

  bindTimeouts() {
    setTimeout(() => this.loadGroup(), 0);
  }

  loadGroup() {
    if (this.$groups.length > 0) {
      window.Turbolinks.visit(this.$groups.first().attr('href'));
    }
  }

  handleResize() {
    this.checkPageFormat();

    if (
      this.currentPageFormat === 'desktop' &&
      this.oldPageFormat !== this.currentPageFormat
    ) {
      this.bindTimeouts();
    }
  }

  checkPageFormat() {
    this.oldPageFormat = this.currentPageFormat;

    if (window.$window.width() > window.pageContentWidthMd) {
      this.currentPageFormat = 'desktop';
    } else {
      this.currentPageFormat = 'mobile';
    }
  }
}
